import { init } from '@mrhenry/wp--mr-interactive';

function setInlineLinkTransitionDuration() {
	const links = Array.from( document.querySelectorAll<HTMLAnchorElement>( ':any-link:not([class]):not([data-did-set-transition-duration])' ) );
	links.forEach( ( link ) => {
		link.setAttribute( 'data-did-set-transition-duration', '' );
		link.style.setProperty( '--inline-link-transition-duration', `${300 + ( ( link.textContent?.length ?? 20 ) * 10 )}ms` );
	} );
}

init( (): boolean => {
	if ( !document.body ) {
		return false;
	}

	setInlineLinkTransitionDuration();

	( new MutationObserver( ( mutationList ) => {
		let hasAdditions = false;

		for ( const mutation of mutationList ) {
			if ( !mutation.addedNodes?.length ) {
				continue;
			}

			for ( let i = 0; i < mutation.addedNodes.length; i++ ) {
				const addedNode = mutation.addedNodes[i];
				const tagName = ( addedNode as Element ).tagName;
				if ( tagName !== 'A' ) {
					continue;
				}

				hasAdditions = true;

				break;
			}
		}

		if ( !hasAdditions ) {
			return;
		}

		setInlineLinkTransitionDuration();
	} ) ).observe( document.body, {
		attributes: false,
		childList: true,
		subtree: true,
	} );

	return true;
} );
